// extracted by mini-css-extract-plugin
export var header = "_vr-1";
export var maskBottom = "_vr-6";
export var maskMiddle = "_vr-7";
export var maskTop = "_vr-5";
export var root = "_vr-0";
export var scrollDownButton = "_vr-3";
export var scrollDownButtonHidden = "_vr-4";
export var viewport = "_vr-2";